import { Action, Types } from './types';

export interface DataState<T> {
  byId: {
    [id: string]: T;
  };
  allIds: string[];
}

export function dataReducer<T, S>(service: S) {
  const initialState: DataState<T> = {
    byId: {},
    allIds: [],
  };

  return (state: DataState<T> = initialState, action: Action<T, S>): DataState<T> => {
    if (action.service !== service) {
      return state;
    }

    switch (action.type) {
      case Types.GET_COLLECTION_REQUESTED:
        return action.payload.clear ? initialState : state;

      case Types.GET_COLLECTION_COMPLETED:
        const allIds: string[] = [];
        const byId: { [id: string]: T } = {};
        action.payload.entities.forEach(entity => {
          allIds.push(entity.id);
          byId[entity.id] = entity.entity;
        });

        return {
          byId,
          allIds,
        };

      case Types.CREATE_COMPLETED:
      case Types.GET_COMPLETED:
      case Types.UPDATE_COMPLETED:
      case Types.PATCH_COMPLETED:
        const concatenatedIds =
          state.allIds.indexOf(action.payload.id) > -1 ? state.allIds : state.allIds.concat(action.payload.id);
        return {
          byId: {
            ...state.byId,
            [action.payload.id]: action.payload.entity,
          },
          allIds: concatenatedIds,
        };

      case Types.DELETE_COMPLETED:
        const entitiesById = {
          ...state.byId,
        };
        delete entitiesById[action.payload.id];
        return {
          byId: entitiesById,
          allIds: state.allIds.filter(id => id !== action.payload.id),
        };

      case Types.CLEAR_ALL:
        return initialState;

      default:
        return state;
    }
  };
}
